export const ScrollAnimation = {
  duration: 500,
  delay: 0,
  smooth: 'easeInOutQuart',
}
